import React from 'react';

/**
 * Reusable single-line text input styled for inline editing (e.g. report titles).
 */
const InlineEditableText = ({
  value,
  onChange,
  onBlur,
  placeholder = 'Untitled',
  disabled = false,
  saving = false,
  className = '',
  title = 'Click to edit',
}) => (
  <input
    type="text"
    value={value}
    onChange={(e) => onChange?.(e.target.value)}
    onBlur={onBlur}
    placeholder={placeholder}
    disabled={disabled}
    title={title}
    className={`min-w-0 flex-1 rounded border border-transparent bg-transparent px-1 py-0.5 text-base font-semibold text-gray-900 truncate transition hover:border-gray-200 focus:border-gray-300 focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#00A884]/30 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    aria-label={title}
  />
);

export default InlineEditableText;
